import { useEffect } from "react";
import { clientConfig } from "@/lib/config/client-config";

type TelegramUser = {
  auth_date: number;
  first_name: string;
  hash: string;
  id: number;
  username: string;
};

type TelegramAuthParams = {
  bot_id: string;
  request_access: boolean;
  userpic: boolean;
};

const globalNamespace = (typeof globalThis !== "undefined" ? globalThis : window) as unknown as {
  Telegram: {
    Login: {
      auth: (data: TelegramAuthParams, callback: (data: TelegramUser) => void) => void;
    };
  };
};

let telegramWidgetScriptLoaded = false;

export const useTelegramWidget = () => {
  useEffect(() => {
    if (telegramWidgetScriptLoaded) return;

    const script = document.createElement("script");
    script.src = "https://telegram.org/js/telegram-widget.js?22";
    script.async = true;
    script.dataset.telegramLogin = "OAuthCedeHub_bot";
    script.id = "telegram-widget-script";
    script.dataset.userpic = "true";
    script.dataset.requestAccess = "write";
    document.body.appendChild(script);
    telegramWidgetScriptLoaded = true;
  }, []);

  const linkTelegramAccount = (): Promise<TelegramUser | false> => {
    return new Promise((resolve) => {
      globalNamespace.Telegram.Login.auth(
        { bot_id: clientConfig.telegramBotId, request_access: true, userpic: true },
        (data) => resolve(data),
      );
    });
  };

  return { linkTelegramAccount };
};
